export default {
  hr: "hr",
  hrs: "hrs",
  min: "min",
  mins: "mins",
  byAdmin: "(by admin)",
  byAdminComparator: "by admin",
};
